import $http from "../axios";

const actions = {
  downloadProductsReport(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(`get-products-report?storeId=${data.storeId}`)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  downloadTransactionsReport(_, data) {
    return new Promise((resolve, reject) => {
      const storeIds =
        data.storeIds && data.storeIds.length
          ? `&storeIds=${data.storeIds.join(",")}`
          : "";
      $http
        .get(
          `get-transactions-report?storeId=${data.storeId}&beginDate=${data.dates[0]}&endDate=${data.dates[1]}${storeIds}`
        )
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  downloadAccessesReport(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `get-accesses-report?storeId=${data.storeId}&beginDate=${data.dates[0]}&endDate=${data.dates[1]}&filter=${data.filter}`
        )
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  downloadFeedbacksReport(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `get-feedbacks-report?storeId=${data.storeId}&beginDate=${data.dates[0]}&endDate=${data.dates[1]}`
        )
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

export default {
  actions
};
